export default "__VITE_ASSET__3079d07e__";